import { FC } from "react";
import { Trans } from "@lingui/macro";
import SalesLandingTextBlock from "src/organisms/SalesLandingView/SalesLandingTextBlock";
import {
  StyledFooterTopSalesLanding,
  StyledSalesLandingTextBlockWrapper,
} from "./FooterTopSalesLanding.styled";

const FooterTopSalesLanding: FC = () => (
  <StyledFooterTopSalesLanding>
    <StyledSalesLandingTextBlockWrapper>
      <SalesLandingTextBlock>
        <Trans>invite your friends</Trans>
        <iframe
          src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&layout=button&size=large&width=77&height=28&appId"
          style={{
            height: 32,
            width: 80,
            marginLeft: 24,
            verticalAlign: "middle",
            border: "none",
            overflow: "hidden",
          }}
          scrolling="no"
          frameBorder="0"
          allow="encrypted-media"
        ></iframe>
      </SalesLandingTextBlock>
    </StyledSalesLandingTextBlockWrapper>
  </StyledFooterTopSalesLanding>
);

export default FooterTopSalesLanding;
